import { ContentSubtypeAction } from '../types/ContentSubtypeAction';
import ContentSubtypeData from '../types/ContentSubtypeData';
import * as libraryActions from '../actions/actionType';

interface ContentSubtypeState {
	list: ContentSubtypeData[],
	question: ContentSubtypeData[],
	ftreQuestion: ContentSubtypeData[],
	aitsQuestion: ContentSubtypeData[],
	nationalLevelQuestion: ContentSubtypeData[],
	testpapers: ContentSubtypeData[],
	studymaterial: ContentSubtypeData[],
	practiceSet: ContentSubtypeData[],
	ftreTestpapers: ContentSubtypeData[],
	aitsTestpapers: ContentSubtypeData[],
	nationalLevelTestpapers: ContentSubtypeData[],
	error: string | null,
	isQuestionSubtypeLoaded: boolean,
	isStudyMaterialSubtypeLoaded: boolean,
};

const initialState: ContentSubtypeState = {
	list: [],
	question: [],
	ftreQuestion: [],
	aitsQuestion: [],
	nationalLevelQuestion: [],
	testpapers: [],
	studymaterial: [],
	practiceSet: [],
	ftreTestpapers: [],
	aitsTestpapers: [],
	nationalLevelTestpapers: [],
	error: null,
	isQuestionSubtypeLoaded: false,
	isStudyMaterialSubtypeLoaded: false,
};

const contentSubtypeReducers = (state = initialState, action: ContentSubtypeAction) => {
	switch (action.type) {
		case 'CONTENT_SUBTYPE_SUCCESS': {
			return { ...state, list: action.data }
		}
		case 'CONTENT_SUBTYPE_FAILED': {
			return { ...state, error: action.error }
		}
		case 'CONTENT_SUBTYPE_QUESTION_SUCCESS': {
			return { ...state, question: action.data, isQuestionSubtypeLoaded: true }
		}
		case 'CONTENT_SUBTYPE_TEST_SUCCESS': {
			return { ...state, testpapers: action.data }
		}
		case 'CONTENT_SUBTYPE_STUDYMATERIAL_SUCCESS': {
			return { ...state, studymaterial: action.data, isStudyMaterialSubtypeLoaded: true }
		}
		case 'CONTENT_SUBTYPE_PRACTICESET_SUCCESS': {
			return { ...state, practiceSet: action.data }
		}
		case 'CONTENT_SUBTYPE_FTRE_QUESTION_SUCCESS': {
			return { ...state, ftreQuestion: action.data }
		}
		case libraryActions.CONTENT_SUBTYPE_FTRE_TESTPAPERS_SUCCESS: {
			return { ...state, ftreTestpapers: action.data }
		}
		case libraryActions.CONTENT_SUBTYPE_AITS_QUESTION_SUCCESS: {
			return { ...state, aitsQuestion: action.data }
		}
		case libraryActions.CONTENT_SUBTYPE_AITS_TESTPAPERS_SUCCESS: {
			return { ...state, aitsTestpapers: action.data }
		}
		case libraryActions.CONTENT_SUBTYPE_NATIONAL_LEVET_QUESTION_SUCCESS: {
			return { ...state, nationalLevelQuestion: action.data }
		}
		case libraryActions.CONTENT_SUBTYPE_NATIONAL_LEVEL_TESTPAPERS_SUCCESS: {
			return { ...state, nationalLevelTestpapers: action.data }
		}
		default:
			return state;
	}
}


export default contentSubtypeReducers;